import { Fragment } from 'preact';
import { styled } from 'goober';
import SlideOne from './slideOne';
import SlideTwo from './slideTwo';
import SlideThree from './slideThree';
import SlideFour from './slideFour';
import SlideFive from './slideFive';
import SlickSlider from '../../common/slickSlider';

const EducationalModal = ({
  shouldShowHtbModal,
  setShouldShowHtbModal,
  pageKey,
}) => {
  const Container = styled('div')`
    box-sizing: border-box;
    margin: 0 !important;
    width: 100%;
    height: auto;
    padding-left: 9px;
    padding-right: 13px;
    border: 5px solid #ccffda;
    background: #f5fffc;
    box-shadow: 4px 4px 15px 6px rgba(0, 0, 0, 0.25);
    border-radius: 25px;
    @media only screen and (max-width: 768px) {
      padding-left: ${({ shouldShowHtbModal }) =>
        !shouldShowHtbModal ? '17px' : '0'};
      padding-right: 0;
      background-size: contain;
    }
  `;

  const Text = styled('span')`
    color: rgba(8, 144, 81, 1);
    font-weight: 600;
    line-height: 1.3;
  `;

  const HtbSectionWrapper = styled('div')`
    padding: 0 12px;
  `;

  const HtbSection = styled('div')`
    width: 100% !important;
    margin: 20px auto 0;
  `;

  const HtbShowContainer = styled('div')`
    padding-top: 15px;
    display: flex !important;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `;

  const CarouselHeaderText = styled('div')`
    width: 72%;
    height: 80px;
    font-size: 15px;
    line-height: 1.7;
    font-weight: 600;
    text-align: center;
    color: black;
    @media only screen and (max-width: 600px) {
      width: 80%;
    }
  `;

  const SliderIndex = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 35px;
    height: 35px;
    margin-top: 10px;
    font-weight: 600;
    background-color: rgba(226, 226, 226, 1);
  `;

  const HtbImage = styled('img')`
    width: 320px;
    height: 325px;
    margin-top: 10px;
    @media only screen and (max-width: 450px) {
      height: 85%;
      width: 82%;
    }
  `;
  const BackButtonFromHtbModal = styled('button')`
    height: 27px;
    width: 27px;
    border: none;
    background: #868686;
    cursor: pointer;
    color: white;
    padding: 2px;
    @media only screen and (max-width: 450px) {
      margin-right: 6px;
    }
    @media only screen and (max-width: 430px) {
      margin-right: 0;
      margin-left: -25px;
    }
  `;

  const newHtbMerchantsSliderData = [
    {
      headerText: (
        <Fragment>
          On <Text>Payment Page</Text>, Choose <Text>EMI</Text>
          (Easy Installments)
        </Fragment>
      ),
      htbImage: 'https://iccdn.in/how-to-buy-assets/emi-select.png',
    },
    {
      headerText: (
        <Fragment>
          Please select{' '}
          <Text>your bank for Cardless EMI from options as shown below</Text>{' '}
        </Fragment>
      ),
      htbImage: 'https://iccdn.in/how-to-buy-assets/lender-select.png',
    },
    {
      headerText: (
        <Fragment>
          Please select <Text>your Installment amount and tenure</Text>{' '}
        </Fragment>
      ),
      htbImage: 'https://iccdn.in/how-to-buy-assets/tenure-select.png',
    },
    {
      headerText: (
        <Fragment>
          Please enter <Text>4 numeric</Text> of your
          <Text> PAN CARD eg</Text>. ALTP <Text>8171</Text>R
        </Fragment>
      ),
      htbImage: 'https://iccdn.in/how-to-buy-assets/verify-section.png',
    },
    {
      headerText: (
        <Fragment>
          <div style={{ display: 'flex', 'align-items': 'start' }}>
            <BackButtonFromHtbModal
              onClick={() => setShouldShowHtbModal(false)}
              className={'material-icons'}>
              arrow_back
            </BackButtonFromHtbModal>
            <span>
              Please <Text>Enter OTP and Verify</Text> to complete your
              transaction &#128525;
            </span>
          </div>
        </Fragment>
      ),
      htbImage: 'https://iccdn.in/how-to-buy-assets/otp-section.png',
    },
  ];

  const newComponentData = [
    {
      component: (
        <Fragment>
          <SlideOne />
        </Fragment>
      ),
    },
    {
      component: (
        <Fragment>
          <SlideTwo />
        </Fragment>
      ),
    },
    {
      component: (
        <Fragment>
          <SlideThree />
        </Fragment>
      ),
    },
    {
      component: (
        <Fragment>
          <SlideFour />
        </Fragment>
      ),
    },
    {
      component: (
        <Fragment>
          <SlideFive
            setShouldShowHtbModal={setShouldShowHtbModal}
            pageKey={pageKey}
          />
        </Fragment>
      ),
    },
  ];

  const sliderSettings = {
    dots: true,
    dotsClass: `slick-dots slick-thumb`,
    customPaging: function() {
      return <div className='customDotsForEducationModal' />;
    },
    autoplay: true,
    speed: 750,
    rows: 1,
    autoplaySpeed: 4000,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    initialSlide: 0,
    placeholders: false,
    mobileFirst: true,
    swipeToSlide: true,
  };

  return (
    <Container
      className={'educationalModalContainer'}
      shouldShowHtbModal={shouldShowHtbModal}>
      {!shouldShowHtbModal ? (
        <SlickSlider setting={sliderSettings}>
          {newComponentData.map((components) => {
            return components.component;
          })}
        </SlickSlider>
      ) : (
        <HtbSectionWrapper>
          <HtbSection>
            <SlickSlider setting={sliderSettings}>
              {newHtbMerchantsSliderData.map((merchantData, index) => {
                return (
                  <HtbShowContainer>
                    <CarouselHeaderText>
                      {merchantData.headerText}
                    </CarouselHeaderText>
                    <SliderIndex>{index + 1}</SliderIndex>
                    <HtbImage
                      src={merchantData.htbImage}
                      alt='Htb steps images'
                    />
                  </HtbShowContainer>
                );
              })}
            </SlickSlider>
          </HtbSection>
        </HtbSectionWrapper>
      )}
    </Container>
  );
};
export default EducationalModal;



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/educationalModal/index.js